import { Project } from 'components/Project/types/project';
import { IClientUserDto } from 'store/user/types/client-user';

export enum ActionTypes {
  SET_LIST = 'projects: set-list',
  SET_LIST_LOADING = 'projects: set-list-loading',
  SET_USERS = 'projects: set-user',
}

export interface ProjectsState {
  list: Array<Project>;
  users: IClientUserDto[]
  loading: boolean
}
